import cookie from 'js-cookie'
var RTCIceCandidate = window.mozRTCIceCandidate || window.RTCIceCandidate

let localConnection
let video
let ws
let reconnectData
let webSocketConnect = false
let address
let roomId
let sendAnswer = false
let loginMessageId
let teachOKCallback = null
let playOKCallback = null
let isManuallyClosed = false
function connect(url, id) {
  sessionStorage.scoket_url = url
  sessionStorage.scoket_roomId = id
  return new Promise((resolve, reject) => {
    console.log(`正在连接服务器 ${url}`)
    address = url
    roomId = id
    ws = new WebSocket(url)
    const loginData = {
      opcode: 'login',
      data: {
        service: 'pt',
        token: localStorage.token
      }
    }
    ws.onopen = () => {
      sendMessage(loginData)
      webSocketConnect = true
      resolve()
    }
    ws.onmessage = event => {
      const response = JSON.parse(event.data)
      if (response.opcode === 'ack' && response.data.code !== 200) return
      receiveMessage(response, roomId)
    }
    ws.onerror = error => {
      reject(error)
      ws.close() // 触发 onclose 事件
    }
    ws.onclose = event => {
      webSocketConnect = false
      console.log('***********  websocket已关闭  **********', event)
      reconnect()
    }
  })
}
function reconnect() {
  if (webSocketConnect || isManuallyClosed) return
  console.log('***********  websocket重连中  **********')
  reconnectData && clearTimeout(reconnectData)
  reconnectData = setTimeout(() => {
    const rScoketUrl = address || sessionStorage.scoket_url
    const rScoketRoomId = roomId || sessionStorage.scoket_roomId
    connect(rScoketUrl, rScoketRoomId)
  }, 500)
}
function getVideo(dom) {
  video = dom
}

function getStartupState(callback) {
  teachOKCallback = callback
}

function getPlayState(callback) {
  playOKCallback = callback
}

function sendMessage(data) {
  let intent
  const messageId = new Date().getTime() + Math.floor(Math.random() * 1000) + 1 + ''
  if (data.opcode === 'event') {
    const content = { ...data.data.content } || {}
    intent = {
      opcode: 'message',
      message_id: messageId,
      data: {
        to: 'room',
        body: Object.assign(content, {
          messageId
        }),
        event: {
          ...data.data
        }
      }
    }
  } else {
    if (data.opcode === 'login') loginMessageId = messageId
    intent = { ...data }
    intent.message_id = messageId
    const content = { ...data.body } || {}
    if (!'login, join'.includes(data.opcode)) {
      intent.body = Object.assign(content, {
        messageId: messageId
      })
    }
  }
  ws.send(JSON.stringify(intent))
}
function receiveMessage(response) {
  if (response.opcode === 'ack') {
    if (response.message_id == loginMessageId) {
      if (response.data.code == 200) {
        const joinRoom = {
          opcode: 'join',
          message_id: '101',
          // body: {
          //   name: 'join'
          // },
          data: {
            roomId: roomId
          }
        }
        sendMessage(joinRoom)
      }
    }
  } else {
    if (!response.data) return
    // 处理连接成功消息
    if (response.data.type) {
      switch (response.data.type) {
        case 'offer':
          initRTCPeerConnection(response.data)
          break
        case 'candidate':
          const { sdpMid, sdpMLineIndex, candidate } = JSON.parse(response.data.data)
          const paylodex = { sdpMid, candidate, sdpMLineIndex, type: 'ice-candidate' }
          if (paylodex) {
            localConnection.addIceCandidate(new RTCIceCandidate(paylodex))
          }
          break
        case 'teach':
        case 'auto_login':
          if (response.data.state === 'success') {
            if (teachOKCallback) teachOKCallback()
          }
          break
      }
    }
    if (response.data.name) {
      switch (response.data.name) {
        case 'OpenResFeedback':
          console.log('OpenResFeedback ----->', JSON.parse(response.data.content))
          if (playOKCallback) playOKCallback(JSON.parse(response.data.content))
          break
      }
    }
  }
}
export function initRTCPeerConnection(data) {
  const connectData = JSON.parse(data.data)
  const RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
  // 配置连接信息
  const iceServers = [
    {
      urls: 'turn:39.106.177.65:3479',
      username: 'demo',
      credential: 'growlib.com'
    },
    {
      urls: 'stun:stun.3deluxe.de'
    },
    {
      urls: 'stun:stun.schlund.de'
    },
    {
      urls: 'stun:stun1.l.google.com:19302'
    }
  ]
  const config = {
    iceServers: iceServers
  }
  // 建立本地连接节点 新的 RTCPeerConnection 对象
  localConnection = new RTCPeerConnection(config)
  let inboundStream = null
  if (localConnection.ontrack != 'undefined') {
    localConnection.ontrack = event => {
      // console.log('gotRemoteStream', event.track, event.streams[0])
      // if (event.streams && event.streams[0]) {
      //   setTimeout(() => {
      //     video.srcObject = event.streams[0]
      //     const playPromise = video.play()
      //     if (playPromise !== null) {
      //       playPromise.catch(() => { video.play() })
      //     }
      //   }, 150)
      // } else {
      //   if (!inboundStream) {
      //     inboundStream = new MediaStream()
      //     setTimeout(() => {
      //       video.srcObject = inboundStream
      //       const playPromise = video.play()
      //       if (playPromise !== null) {
      //         playPromise.catch(() => { video.play() })
      //       }
      //     }, 150)
      //   }
      //   inboundStream.addTrack(event.track)
      // }console.log('gotRemoteStream', event.track, event.streams[0])
      // if (event.streams && event.streams[0]) {
      //   setTimeout(() => {
      //     video.srcObject = event.streams[0]
      //     const playPromise = video.play()
      //     if (playPromise !== null) {
      //       playPromise.catch(() => { video.play() })
      //     }
      //   }, 150)
      // } else {
      //   if (!inboundStream) {
      //     inboundStream = new MediaStream()
      //     setTimeout(() => {
      //       video.srcObject = inboundStream
      //       const playPromise = video.play()
      //       if (playPromise !== null) {
      //         playPromise.catch(() => { video.play() })
      //       }
      //     }, 150)
      //   }
      //   inboundStream.addTrack(event.track)
      // }
    }
  } else {
    localConnection.onaddstream = event => {
      if (event.stream) {
        video.srcObject = event.stream
      } else {
        if (!inboundStream) {
          inboundStream = new MediaStream()
          setTimeout(() => {
            video.srcObject = inboundStream
            const playPromise = video.play()
            if (playPromise !== null) {
              playPromise.catch(() => {
                video.play()
              })
            }
          }, 150)
        }
        inboundStream.addTrack(event.track)
      }
    }
  }
  localConnection.onicecandidate = event => {
    if (!event || !event.candidate || !sendAnswer) return
    const obj = {
      opcode: 'message',
      message_id: '668',
      data: {
        to: data.from,
        name: 'webRtcMsg',
        body: {
          to: data.from,
          type: 'candidate',
          name: 'webRtcMsg',
          data: JSON.stringify(event.candidate),
          from: 'teacher_' + cookie.getJSON('user_infor').id
        }
      }
    }
    sendMessage(obj)
  }
  // 监听onaddstream获取实时播控视频流
  localConnection.onaddstream = event => {
    if (event.stream) {
      video.srcObject = event.stream
    } else {
      if (!inboundStream) {
        inboundStream = new MediaStream()
        setTimeout(() => {
          video.srcObject = inboundStream
          const playPromise = video.play()
          if (playPromise !== null) {
            playPromise.catch(() => {
              video.play()
            })
          }
        }, 150)
      }
      inboundStream.addTrack(event.track)
    }
  }
  // 设置远端描述信息 SDP
  const RTCSessionDescription =
    window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription
  localConnection.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp: connectData.sdp }))
  if (!sendAnswer) {
    localConnection
      .createAnswer()
      .then(answer => {
        const obj = {
          opcode: 'message',
          message_id: '667',
          data: {
            to: data.from,
            name: 'webRtcMsg',
            body: {
              to: data.from,
              name: 'webRtcMsg',
              type: 'answer',
              data: JSON.stringify({ sdp: answer.sdp }),
              from: 'teacher_' + cookie.getJSON('user_infor').id
            }
          }
        }
        sendMessage(obj)
        sendAnswer = true
        // console.log('发送answer')
        return localConnection.setLocalDescription(answer)
      })
      .then(function() {
        // Send the answer to the remote peer through the signaling server.
      })
      .catch(error => {
        console.log(error)
      })
  }
}
function closeWebsocket() {
  isManuallyClosed = true
  ws.close()
  ws = null
  address = ''
  roomId = undefined
  webSocketConnect = false
  reconnectData && clearTimeout(reconnectData)
}

function closeRTCPeerConnection() {
  video = null
  sendAnswer = false
  if (localConnection) {
    localConnection.close()
    localConnection = null
  }
}
export const vrClicent = {
  close,
  connect,
  getVideo,
  sendMessage,
  closeWebsocket,
  getStartupState,
  initRTCPeerConnection,
  closeRTCPeerConnection,
  getPlayState
}
